var _regeneratorRuntime = require("/opt/buildhome/repo/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/createClass");

var axios = require("axios");

var _ = require("lodash");

var AnnoymousAuth = require("./auth/AnnoymousAuth");

var APIProviderError = require("./APIProviderError");

var Analytics = require("./resource/Analytics");

var Announcements = require("./resource/Announcements");

var AuditLog = require("./resource/AuditLog");

var Auth = require("./resource/Auth");

var Content = require("./resource/Content");

var ContentCount = require("./resource/ContentCount");

var ContentRetrieve = require("./resource/ContentRetrieve");

var ContentRevisions = require("./resource/ContentRevisions");

var ContentUpload = require("./resource/ContentUpload");

var ContentType = require("./resource/ContentType");

var IAM = require("./resource/IAM");

var Indexing = require("./resource/Indexing");

var Files = require("./resource/Files");

var Forms = require("./resource/Forms");

var Integrations = require("./resource/Integrations");

var Integrators = require("./resource/Integrators");

var Plugins = require("./resource/Plugins");

var Notifications = require("./resource/Notifications");

var PostStatus = require("./resource/PostStatus");

var Settings = require("./resource/Settings");

var Sites = require("./resource/Sites");

var SiteTypes = require("./resource/SiteTypes");

var SmartFeedSettings = require("./resource/SmartFeedSettings");

var Status = require("./resource/Status");

var Template = require("./resource/Template");

var Webhooks = require("./resource/Webhooks");

var WeducEntities = require("./resource/WeducEntities");

var WeducSettings = require("./resource/WeducSettings");

var WeducUsers = require("./resource/WeducUsers");

var Workflow = require("./resource/Workflow");

var APIProvider = /*#__PURE__*/function () {
  "use strict";

  function APIProvider(options) {
    _classCallCheck(this, APIProvider);

    this.options = _.merge({
      baseUrl: "https://api.accropress.com",
      accropress_cms_preview_jwt: null,
      tenantId: null,
      integratorId: null,
      accessToken: null
    }, options);
    this.analytics = new Analytics(this);
    this.announcements = new Announcements(this);
    this.auditlog = new AuditLog(this);
    this.auth = new Auth(this);
    this.content = new Content(this);
    this.contentCount = new ContentCount(this);
    this.contentUpload = new ContentUpload(this);
    this.contentRevisions = new ContentRevisions(this);
    this.contentRetrieve = new ContentRetrieve(this);
    this.contentType = new ContentType(this);
    this.files = new Files(this);
    this.forms = new Forms(this);
    this.iam = new IAM(this);
    this.indexing = new Indexing(this);
    this.intergrations = new Integrations(this);
    this.integrators = new Integrators(this);
    this.notifications = new Notifications(this);
    this.plugins = new Plugins(this);
    this.postStatus = new PostStatus(this);
    this.settings = new Settings(this);
    this.sites = new Sites(this);
    this.siteTypes = new SiteTypes(this);
    this.smartfeed = new SmartFeedSettings(this);
    this.status = new Status(this);
    this.template = new Template(this);
    this.webhooks = new Webhooks(this);
    this.weducEntities = new WeducEntities(this);
    this.weducSettings = new WeducSettings(this);
    this.weducUsers = new WeducUsers(this);
    this.workflow = new Workflow(this);
  }

  _createClass(APIProvider, [{
    key: "get",
    value: function get(path, options) {
      return this._request("get", path, options);
    }
  }, {
    key: "post",
    value: function post(path, data) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var config = options;
      config.data = data;
      return this._request("post", path, config);
    }
  }, {
    key: "put",
    value: function put(path, data) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var config = options;
      config.data = data;
      return this._request("put", path, config);
    }
  }, {
    key: "patch",
    value: function patch(path, data) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var config = options;
      config.data = data;
      return this._request("patch", path, config);
    }
  }, {
    key: "head",
    value: function head(path, data) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var config = options;
      config.data = data;
      return this._request("head", path, config);
    }
  }, {
    key: "delete",
    value: function _delete(path, data) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var config = options;
      config.data = data;
      return this._request("delete", path, options);
    }
  }, {
    key: "_request",
    value: function () {
      var _request2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(method, path, config) {
        var request, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                request = config;
                request.url = "".concat(this.options.baseUrl, "/").concat(path);
                request.method = method;
                request.withCredentials = true;
                if (!request.headers) request.headers = {};

                if (this.options.accropress_cms_preview_jwt) {
                  request.headers["Authorization"] = "Bearer " + this.options.accropress_cms_preview_jwt;
                }

                request = _.merge(request, this.options);
                _context.prev = 7;
                _context.next = 10;
                return axios.request(request);

              case 10:
                response = _context.sent;
                return _context.abrupt("return", this._handleResponse(request, response));

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](7);
                return _context.abrupt("return", this._handleError(request, _context.t0));

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 14]]);
      }));

      function _request(_x, _x2, _x3) {
        return _request2.apply(this, arguments);
      }

      return _request;
    }()
  }, {
    key: "_handleResponse",
    value: function () {
      var _handleResponse2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(request, response) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.options.onResponse) {
                  _context2.next = 3;
                  break;
                }

                _context2.next = 3;
                return Promise.resolve(this.options.onResponse(request, response));

              case 3:
                return _context2.abrupt("return", response);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _handleResponse(_x4, _x5) {
        return _handleResponse2.apply(this, arguments);
      }

      return _handleResponse;
    }()
  }, {
    key: "_handleError",
    value: function () {
      var _handleError2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(request, error) {
        var clientError;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log("error when requesting:" + request.url);
                console.error(error);
                clientError = new APIProviderError(error);

                if (!this.options.onError) {
                  _context3.next = 6;
                  break;
                }

                _context3.next = 6;
                return Promise.resolve(this.options.onError(request, clientError));

              case 6:
                return _context3.abrupt("return", {
                  'status': 'Error',
                  'message': clientError
                });

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function _handleError(_x6, _x7) {
        return _handleError2.apply(this, arguments);
      }

      return _handleError;
    }()
  }]);

  return APIProvider;
}();

module.exports = APIProvider;